<template>
    <div>
<!--        "<strong>{{ $_.get(activity, "payload.name") }}</strong-->
<!--        >" tag removed by-->
<!--        <strong> {{ $_.get(activity, "actorUser.name") }}</strong>-->
        <span v-html="$t('notification.tagRemoved', { user: $_.get(activity, 'actorUser.name'), tag:$_.get(activity, 'payload.name') })"></span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "TagsRemoved",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
